// Angular
import { Component, Input, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'mentor-upload-outcome',
  template: `
    <div>
      <vrm-dialog-header [dialogTitle]="title" [hideDivider]="true"></vrm-dialog-header>
      <div [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'">
        <p style="color: #008000a6; padding: 10px">
          {{ successfully }} {{ subject }} {{ 'USER.uploadedSuccessfully' | translate }}
        </p>
        <p [hidden]="exists == 0" style="color: #ff0000b6; padding: 10px">
          {{ exists }} {{ subject }} {{ 'USER.alreadyExists' | translate }}
        </p>
      </div>
    </div>
  `,
})
export class UploadOutcomeComponent implements OnInit {
  @Input() title: string;
  @Input() exists: number;
  @Input() successfully: number;
  @Input() subject: string;

  constructor(
    public dialogRef: MatDialogRef<UploadOutcomeComponent>,
    public cService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    console.log('DIALOG DATA', this.data);
    this.exists = this.data.exists;
    this.successfully = this.data.successfully;
    this.subject = this.data.subject;
    this.title = this.data.title;
  }
}
